import { TenantEntity } from '../TenantEntity'

export class AirUld extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get joinContainerId() {
    return this._data.joinContainerId
  }
  set joinContainerId(joinContainerId) {
    this._data.joinContainerId = joinContainerId || 0
  }
  get uldId() {
    return this._data.uldId
  }
  set uldId(uldId) {
    this._data.uldId = uldId || 0
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get containerType() {
    return this._data.containerType
  }
  set containerType(containerType) {
    this._data.containerType = containerType
  }
  get containerCode() {
    return this._data.containerCode
  }
  set containerCode(containerCode) {
    this._data.containerCode = containerCode
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity
  }
  get board() {
    return this._data.board
  }
  set board(board) {
    this._data.board = board
  }
}
